/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const MONITORING_SITE_LIST_STRINGS = {
  emptyStateHeading: 'There are no sites set up to be monitored',
  emptyStateSubheading: 'Contact customer success to set up sites.',
  errorStateHeading: 'An error occurred while fetching the domains',
  errorStateSubheading: 'Please try again later.',
} as const;
